import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type PayloadActionForAPI, type PayloadActionForFirebase } from "../../types/app";
import { type APIConfig } from "../../types/api";
import { type AuthSSOProvider, type FirebaseUser, type User } from "../../types/user";

export type UserSliceState = {
   firebaseUser?: FirebaseUser;
   firebaseUserIdToken?: string;
   user?: User;
   userLoaded: boolean;
};

const initialState: UserSliceState = {
   userLoaded: false,
};

export const userSlice = createSlice({
   name: "user",
   initialState,
   reducers: {
      signUpWithEmailAndPassword: (
         _,
         __: PayloadActionForFirebase<{
            fullName: string;
            email: string;
            password: string;
         }>,
      ) => {},
      loginWithEmailAndPassword: (
         _,
         __: PayloadActionForFirebase<
            {
               email: string;
               password: string;
            },
            {
               firebaseUser: FirebaseUser;
            }
         >,
      ) => {},
      loginWithProvider: (
         _,
         __: PayloadActionForFirebase<
            {
               provider: AuthSSOProvider;
            },
            {
               firebaseUser: FirebaseUser;
            }
         >,
      ) => {},
      loadUser: () => {},
      logout: (
         _,
         __: PayloadActionForFirebase<{
            doNotInformUser?: boolean;
         }>,
      ) => {},
      deleteFirebaseUser: (
         _,
         __: PayloadActionForFirebase<{
            email: string;
            password: string;
         }>,
      ) => {},
      setFirebaseUser: (state, action: PayloadAction<UserSliceState["firebaseUser"]>) => {
         state.firebaseUser = action.payload;
      },
      setFirebaseUserIdToken: (state, action: PayloadAction<UserSliceState["firebaseUserIdToken"]>) => {
         state.firebaseUserIdToken = action.payload;
      },
      setUser: (state, action: PayloadAction<UserSliceState["user"]>) => {
         state.user = action.payload;
      },
      setUserLoaded: (state, action: PayloadAction<UserSliceState["userLoaded"]>) => {
         state.userLoaded = action.payload;
      },
      sendEmailVerification: () => {},
      editFirebaseUserData: (
         _,
         __: PayloadActionForFirebase<{
            displayName?: string;
            photoURL?: string;
         }>,
      ) => {},
      editUserData: (_, __: PayloadActionForAPI<APIConfig["editUser"]>) => {},
      editFirebaseUserProfileImage: (
         _,
         __: PayloadActionForFirebase<{
            file: File | undefined;
         }>,
      ) => {},
      changePassword: (
         _,
         __: PayloadActionForFirebase<{
            currentPassword?: string;
            newPassword: string;
         }>,
      ) => {},
   },
});
